import React from "react";
import "./CancellationPolicy.css";

const CancellationPolicy = () => {
  document.body.scrollTop = 0; // For Safari
  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  return (
    <div>
      <h1>This is CancellationPolicy</h1>
    </div>
  );
};

export default CancellationPolicy;
